<template>
  <b-card v-if="siteId && targetMonth" class="mb-4" title="安全衛生目標および所信表明">
    <b-form v-if="isManagedUser" @submit.prevent="saveSummary">
      <b-row>
        <b-col md="12">
          <b-form-group label="所長の所信表明" label-for="director-statement">
            <b-form-textarea
              id="director-statement"
              v-model="summaryForm.directorStatement"
              rows="3"
              placeholder="所長の所信表明を入力してください"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="所長の所信表明への具体的事項" label-for="director-statement-details">
            <b-form-textarea
              id="director-statement-details"
              v-model="summaryForm.directorStatementDetails"
              rows="3"
              placeholder="所長の所信表明への具体的事項を入力してください"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-card border-variant="warning" class="mb-3">
            <b-table-simple bordered small responsive class="border-warning">
              <b-tbody>
                <b-tr>
                  <b-th scope="row" class="text-center align-middle" style="white-space: pre-line; width: 22%;">安全衛生方針
（全社＋作業所）</b-th>
                  <b-td>
                    <b-form-textarea
                      id="site-own-goal"
                      v-model="summaryForm.siteOwnGoal"
                      rows="3"
                      placeholder="作業所独自方針を入力してください"
                    />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th scope="row" class="text-center align-middle" style="white-space: pre-line;">全工期作業所
安全衛生目標</b-th>
                  <b-td>
                    <b-form-textarea
                      id="site-safety-health-goal"
                      v-model="summaryForm.siteSafetyHealthGoal"
                      rows="3"
                      placeholder="全工期作業所の安全衛生目標を入力してください"
                    />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-card border-variant="success" class="mb-3">
            <b-table-simple bordered small responsive>
              <b-thead>
                <b-tr>
                  <b-th class="text-center">今月の安全衛生目標</b-th>
                  <b-th class="text-center">危険性・有害性（予想される災害など）</b-th>
                  <b-th class="text-center">除去・低減策（防止対策）</b-th>
                  <b-th class="text-center">確認責任者</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>
                    <b-form-textarea
                      id="monthly-safety-health-goal"
                      v-model="summaryForm.monthlySafetyHealthGoal"
                      rows="3"
                      placeholder="今月の安全衛生目標を入力してください"
                    />
                  </b-td>
                  <b-td>
                    <b-form-textarea
                      id="hazard-or-risk"
                      v-model="summaryForm.hazardOrRisk"
                      rows="3"
                      placeholder="危険性・有害性（予想される災害など）を入力してください"
                    />
                  </b-td>
                  <b-td>
                    <b-form-textarea
                      id="prevention-measures"
                      v-model="summaryForm.preventionMeasures"
                      rows="3"
                      placeholder="除去・低減策（防止対策）を入力してください"
                    />
                  </b-td>
                  <b-td>
                    <b-form-input
                      id="responsible-person"
                      v-model="summaryForm.responsiblePerson"
                      placeholder="確認責任者を入力してください"
                    />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button type="submit" variant="primary">
            {{ summaryForm.id ? '更新' : '保存' }}
          </b-button>
          <b-button v-if="summaryForm.id" @click="cancelEdit" variant="secondary" class="ml-2">
            キャンセル
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <div v-else class="mt-3">
      <p class="text-muted">閲覧のみ可能です</p>
      <b-row v-if="existingSummary">
        <b-col md="12">
          <dl class="row">
            <dt class="col-sm-4">所長の所信表明</dt>
            <dd class="col-sm-8">{{ existingSummary.directorStatement || '-' }}</dd>
            
            <dt class="col-sm-4">所長の所信表明への具体的事項</dt>
            <dd class="col-sm-8">{{ existingSummary.directorStatementDetails || '-' }}</dd>
            
            <dt class="col-sm-4">作業所独自方針</dt>
            <dd class="col-sm-8">{{ existingSummary.siteOwnGoal || '-' }}</dd>
            
            <dt class="col-sm-4">全工期作業所の安全衛生目標</dt>
            <dd class="col-sm-8">{{ existingSummary.siteSafetyHealthGoal || '-' }}</dd>
            
            <dt class="col-sm-4">今月の安全衛生目標</dt>
            <dd class="col-sm-8">{{ existingSummary.monthlySafetyHealthGoal || '-' }}</dd>
            
            <dt class="col-sm-4">危険性・有害性</dt>
            <dd class="col-sm-8">{{ existingSummary.hazardOrRisk || '-' }}</dd>
            
            <dt class="col-sm-4">除去・低減策</dt>
            <dd class="col-sm-8">{{ existingSummary.preventionMeasures || '-' }}</dd>
            
            <dt class="col-sm-4">確認責任者</dt>
            <dd class="col-sm-8">{{ existingSummary.responsiblePerson || '-' }}</dd>
          </dl>
        </b-col>
      </b-row>
      <p v-else class="text-muted">データがありません</p>
    </div>
  </b-card>
</template>

<script>
import SiteSafetyHealthSummaryApi from '@/api/SiteSafetyHealthSummaryApi'

export default {
  name: 'SummaryForm',
  props: {
    siteId: {
      type: String,
      default: null
    },
    targetMonth: {
      type: String,
      default: null
    },
    isManagedUser: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      existingSummary: null,
      summaryForm: {
        id: null,
        directorStatement: '',
        directorStatementDetails: '',
        siteOwnGoal: '',
        siteSafetyHealthGoal: '',
        monthlySafetyHealthGoal: '',
        hazardOrRisk: '',
        preventionMeasures: '',
        responsiblePerson: ''
      }
    }
  },
  watch: {
    siteId: {
      handler() {
        if (this.siteId && this.targetMonth) {
          this.loadSummary()
        }
      }
    },
    targetMonth: {
      handler() {
        if (this.siteId && this.targetMonth) {
          this.loadSummary()
        }
      }
    }
  },
  mounted() {
    if (this.siteId && this.targetMonth) {
      this.loadSummary()
    }
  },
  methods: {
    async loadSummary() {
      if (!this.siteId || !this.targetMonth) {
        return
      }

      try {
        const targetDate = new Date(this.targetMonth + '-01')
        const response = await SiteSafetyHealthSummaryApi.getSummary({
          siteId: this.siteId,
          targetMonth: targetDate.toISOString().split('T')[0]
        })
        
        if (response.data) {
          this.existingSummary = response.data
          this.summaryForm = {
            id: response.data.id,
            directorStatement: response.data.directorStatement || '',
            directorStatementDetails: response.data.directorStatementDetails || '',
            siteOwnGoal: response.data.siteOwnGoal || '',
            siteSafetyHealthGoal: response.data.siteSafetyHealthGoal || '',
            monthlySafetyHealthGoal: response.data.monthlySafetyHealthGoal || '',
            hazardOrRisk: response.data.hazardOrRisk || '',
            preventionMeasures: response.data.preventionMeasures || '',
            responsiblePerson: response.data.responsiblePerson || ''
          }
        } else {
          this.existingSummary = null
          this.resetForm()
        }
      } catch (error) {
        console.error('Failed to load summary:', error)
        if (error.response && error.response.status === 404) {
          this.existingSummary = null
          this.resetForm()
        } else {
          this.$bvToast.toast('安全衛生目標および所信表明の読み込みに失敗しました', {
            title: 'エラー',
            variant: 'danger'
          })
        }
      }
    },
    async saveSummary() {
      if (!this.siteId || !this.targetMonth) {
        this.$bvToast.toast('現場と対象月を選択してください', {
          title: 'エラー',
          variant: 'warning'
        })
        return
      }

      try {
        const targetDate = new Date(this.targetMonth + '-01')
        const data = {
          siteId: this.siteId,
          targetMonth: targetDate.toISOString().split('T')[0],
          directorStatement: this.summaryForm.directorStatement || null,
          directorStatementDetails: this.summaryForm.directorStatementDetails || null,
          siteOwnGoal: this.summaryForm.siteOwnGoal || null,
          siteSafetyHealthGoal: this.summaryForm.siteSafetyHealthGoal || null,
          monthlySafetyHealthGoal: this.summaryForm.monthlySafetyHealthGoal || null,
          hazardOrRisk: this.summaryForm.hazardOrRisk || null,
          preventionMeasures: this.summaryForm.preventionMeasures || null,
          responsiblePerson: this.summaryForm.responsiblePerson || null
        }

        if (this.summaryForm.id) {
          await SiteSafetyHealthSummaryApi.updateSummary(this.summaryForm.id, {
            directorStatement: data.directorStatement,
            directorStatementDetails: data.directorStatementDetails,
            siteOwnGoal: data.siteOwnGoal,
            siteSafetyHealthGoal: data.siteSafetyHealthGoal,
            monthlySafetyHealthGoal: data.monthlySafetyHealthGoal,
            hazardOrRisk: data.hazardOrRisk,
            preventionMeasures: data.preventionMeasures,
            responsiblePerson: data.responsiblePerson
          })
          this.$bvToast.toast('安全衛生目標および所信表明を更新しました', {
            title: '成功',
            variant: 'success'
          })
        } else {
          await SiteSafetyHealthSummaryApi.createSummary(data)
          this.$bvToast.toast('安全衛生目標および所信表明を保存しました', {
            title: '成功',
            variant: 'success'
          })
        }

        await this.loadSummary()
      } catch (error) {
        console.error('Failed to save summary:', error)
        this.$bvToast.toast('安全衛生目標および所信表明の保存に失敗しました', {
          title: 'エラー',
          variant: 'danger'
        })
      }
    },
    resetForm() {
      this.summaryForm = {
        id: null,
        directorStatement: '',
        directorStatementDetails: '',
        siteOwnGoal: '',
        siteSafetyHealthGoal: '',
        monthlySafetyHealthGoal: '',
        hazardOrRisk: '',
        preventionMeasures: '',
        responsiblePerson: ''
      }
    },
    cancelEdit() {
      if (this.existingSummary) {
        this.summaryForm = {
          id: this.existingSummary.id,
          directorStatement: this.existingSummary.directorStatement || '',
          directorStatementDetails: this.existingSummary.directorStatementDetails || '',
          siteOwnGoal: this.existingSummary.siteOwnGoal || '',
          siteSafetyHealthGoal: this.existingSummary.siteSafetyHealthGoal || '',
          monthlySafetyHealthGoal: this.existingSummary.monthlySafetyHealthGoal || '',
          hazardOrRisk: this.existingSummary.hazardOrRisk || '',
          preventionMeasures: this.existingSummary.preventionMeasures || '',
          responsiblePerson: this.existingSummary.responsiblePerson || ''
        }
      } else {
        this.resetForm()
      }
    }
  }
}
</script>

<style scoped>
dl.row {
  margin-bottom: 0;
}

dl.row dt {
  font-weight: bold;
  padding: 8px 0;
}

dl.row dd {
  padding: 8px 0;
  border-bottom: 1px solid #dee2e6;
}

dl.row dd:last-child {
  border-bottom: none;
}
</style>
